import { IPlatformData } from 'interfaces/config/appConfig';
// import yesPlatformText from 'constants/platformLabels/yesPlatformText';
import agbPlatformText from 'constants/platformLabels/agbPlatformText';
// import YesPages from 'routes/manageRoute/platformRoutes/YesRoutes';
import AGBPages from 'routes/manageRoute/platformRoutes/AGBRoutes';
import requestOptions from './requestOptions';

export const Platform = {
  AGB: 'agb',
};

export const CURRENT_PLATFORM =
  String(process.env.REACT_APP_PLATFORM || '').toLowerCase() ||
  Platform.AGB;

const platformData: IPlatformData = {
  [Platform.AGB]: {
    text: agbPlatformText,
    pages: AGBPages,
    requestOption: requestOptions.AGBRequestItem,
  },
  // Add configurations for other platforms (MtoU, etc.) here if needed
};

export const AppConfig = (
  platform: string = CURRENT_PLATFORM,
): IPlatformData => {
  return platformData[platform] || platformData[Platform.AGB];
};
